<template>
  <Modal :value="value" :title="title" :footer-hide="true" :mask-closable="false" width="600" @on-cancel="cancel">
    <div>
      <div v-if="value" ref="contentForm" class="content-form" style="width: 100%;margin-left: 0;">
        <div :class="['content-form-item', formItemClass]">
          <Select v-model="query.template_id" placeholder="治疗阶段">
            <Option value="" key="">全部</Option>
            <Option v-for="t in templateList" :key="t.id" :value="t.id">{{t.name}}</Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select
            v-model="query.is_finish"
            placeholder="完成情况"
            @on-change="getContentList"
          >
            <Option value="" key="">全部</Option>
            <Option :value="0" :key="0">未完成</Option>
            <Option :value="1" :key="1">已完成</Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select
            v-model="query.event_type"
            placeholder="活动类型"
            @on-change="getContentList"
          >
            <Option value="" key="">全部</Option>
            <Option :value="0" :key="0">例行活动</Option>
            <Option :value="1" :key="1">关键活动</Option>
            <Option :value="2" :key="2">临时活动</Option>
          </Select>
        </div>
        <div :class="['content-form-item', formItemClass]">
          <Select
            v-model="query.type"
            placeholder="日程类型"
            @on-change="getContentList"
          >
            <Option value="" key="">全部</Option>
            <Option v-for="t in type" :key="t.value" :value="t.value">{{t.text}}</Option>
          </Select>
        </div>
        <div :class="['content-form-item-date', formDateClass]">
          <DatePicker :value="query.time" :options="options" confirm type="daterange" style="width: 100%" placement="bottom" placeholder="请选择起始时间至截止时间" @on-change="handleDateChange" @on-ok="handleDateConfirm"></DatePicker>
        </div>
      </div>
      <div v-if="loading"
        style="display: inline-block;width: 100%;height: 300px;position: relative;">
        <Spin size="large" fix></Spin>
      </div>
      <div v-else-if="list.length" class="schedule-list" style="maxHeight: calc(100vh - 400px)">
        <div class="schedule-item" v-for="item in list" :key="item.key">
          <div class="schedule-title">{{item.key}} {{item.day}}</div>
          <activity-wrap v-for="l in item.list" :key="l.id" :l="l"
            :is_edit="historyEdit" :is_redirect="historyRedirect"
            style="margin-top: 16px" />
        </div>
      </div>
      <div v-else style="position: relative; height: 300px">
        <caringNoData></caringNoData>
      </div>
    </div>
  </Modal>
</template>
<script>
import {
  getPatientActivityListApi,
} from "../../../api/scheme"
import CaringNoData from "../../common/caringNoData.vue";
import ActivityWrap from "../components/activityWrap.vue";
import { formatDate } from "../../../utils/date";

const type = [
  {
    text: "用药",
    value: "medicine",
  },
  {
    text: "宣教",
    value: "article",
  },
  {
    text: "复诊",
    value: "visit",
  },
  {
    text: "问卷",
    value: "survey",
  },
];
export default {
  components: {
    CaringNoData,
    ActivityWrap
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    id: {
      type: String | Number,
      default: ""
    },
    user_id: {
      type: String | Number,
      default: ""
    },
  },
  data() {
    return {
      formItemClass: "flex-6",
      formDateClass: "flex-12",
      loading: false,
      list: [],
      type,
      options: {
        shortcuts: [
          {
            text: '近一周',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            },
          },
          {
            text: '近一个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
          },
          {
            text: '近三个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            },
          },
        ],
      }, // 时间options
      query: {
        template_id: "",
        is_finish: "",
        event_type: "",
        type: "",
        time: [formatDate(new Date() , -6), formatDate(new Date()) ]
      },
      historyEdit: false,
      historyRedirect: false
    }
  },
  computed: {
    templateList() {
      return []
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.getContentList();
      } else {
        this.query = {
          template_id: "",
          is_finish: "",
          event_type: "",
          type: "",
          time: [formatDate(new Date() , -6), formatDate(new Date())]
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcWidth();
    });
    window.addEventListener('resize', this.calcWidth, true);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.clientWidth, true);
  },
  methods: {
    handleDateConfirm() {
      this.getContentList();
    },
    handleDateChange(v) {
      this.query.time = v;
    },
    calcWidth() {
      const { clientWidth } = this.$refs.contentForm || {};
      if (clientWidth >= 900) {
        this.formItemClass = 'flex-4';
        this.formDateClass = 'flex-8';
      } else if (clientWidth >= 600) {
        this.formItemClass = 'flex-6';
        this.formDateClass = 'flex-12';
      } else if (clientWidth >= 450) {
        this.formItemClass = 'flex-8';
        this.formDateClass = 'flex-16';
      } else {
        this.formItemClass = 'flex-12';
        this.formDateClass = 'flex-24';
      }
    },
    getContentList() {
      this.loading = true;
      const { template_id, is_finish, event_type, type, time } = this.query;
      const [ start_date, end_date ] = time;
      getPatientActivityListApi({
        patient_id: this.user_id,
        template_id: template_id ? template_id : this.id,
        is_finish,
        event_type,
        type,
        orders: "start_time desc",
        start_time: start_date ? (start_date + ' 00:00:00') : '',
        end_time: end_date ? (end_date + ' 23:59:59') : ''
      }).then(res => {
        this.loading = false
        if (res.code === 0) {
          let arr = [];
          (res.data || []).forEach((v) => {
            const key = v.start_time.slice(0, 10);
            const day = new Date(key).getDay();
            const week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
            if (!arr.find(a => a.key === key)) {
              arr.push({
                key,
                day: week[day],
                list: []
              })
            }
            v.extra = JSON.parse(v.extra);
            v.origin_extra = JSON.parse(v.origin_extra);
            const a = arr.find(a => a.key === key);
            v.list = [];
            v.date_show = formatDate(new Date(v.start_time)) <= formatDate();
            this.type.forEach((t) => {
              (v.origin_extra[t.value + "s"] || []).map((item) => {
                item.type = t.value;
                item.type_name = t.text;
                item.extra = v.extra[t.value + "s"].find(e => e.id === item.id)
                v.list.push(item);
              });
            });

            a.list.push(v);
          });
          this.list = arr;
        } else {
          this.$Message.error(res.message);
        }
      }).catch(() => {
        this.loading = false
      })
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="less">
  .content-form{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &-item{
      padding: 0 8px 8px;
      min-width: 150px;
    }
    &-item-date{
      padding: 0 8px 8px;
      min-width: 300px;
    }
    .flex-6{
      flex: 0 0 25%;
    }
    .flex-12{
      flex: 0 0 50%;
    }
    .flex-4{
      flex: 0 0 16.67%;
    }
    .flex-8{
      flex: 0 0 33.32%;
    }
    .flex-16{
      flex: 0 0 66.64%;
    }
    .flex-24{
      flex: 0 0 100%;
    }
  }
  .schedule-list{
    position: relative;
    margin-top: 20px;
    padding-right: 16px;
    overflow-y: auto;
    .schedule-title{
      color: #b4c1d4;
      position: relative;
      &::before {
        position: absolute;
        content: " ";
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        left: -30px;
        background: #5d7ff8;
        border-radius: 50%;
      }
      &::after {
        position: absolute;
        content: " ";
        top: 50%;
        transform: translateY(-50%);
        width: 8px;
        height: 8px;
        left: -24px;
        background: #fff;
        border-radius: 50%;
      }
    }
    .schedule-item{
      position: relative;
      padding-left: 30px;
      margin-bottom: 20px;
      &::after {
        position: absolute;
        content: " ";
        top: 30px;
        left: 10px;
        width: 1px;
        height: calc(~" 100% " - ~" 20px ");
        background: #e4e7ed;
      }
      &:last-child {
        &::after {
          content: none;
        }
      }
    }
  }
</style>
